var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 39,
    viewBox: "0 0 135 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.843 38.9876H5.76017C3.0316 38.9876 0.796875 36.8063 0.796875 34.143V5.07543C0.796875 2.41212 3.0316 0.230836 5.76017 0.230836H129.843C132.571 0.230836 134.806 2.41212 134.806 5.07543V34.143C134.806 36.8063 132.571 38.9876 129.843 38.9876Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.843 1.00718C132.141 1.00718 134.011 2.83239 134.011 5.07543V34.143C134.011 36.3861 132.141 38.2113 129.843 38.2113H5.76017C3.46217 38.2113 1.59224 36.3861 1.59224 34.143V5.07543C1.59224 2.83239 3.46217 1.00718 5.76017 1.00718H129.843ZM129.843 0.230836H5.76017C3.0316 0.230836 0.796875 2.41212 0.796875 5.07543V34.143C0.796875 36.8063 3.0316 38.9876 5.76017 38.9876H129.843C132.571 38.9876 134.806 36.8063 134.806 34.143V5.07543C134.806 2.41212 132.571 0.230836 129.843 0.230836Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8647 10.1562C47.8647 10.9653 47.6165 11.6132 47.1276 12.0965C46.5655 12.6693 45.8333 12.9576 44.9361 12.9576C44.0786 12.9576 43.3465 12.6645 42.7459 12.0868C42.144 11.5006 41.8438 10.7812 41.8438 9.92004C41.8438 9.05891 42.144 8.33949 42.7459 7.75814C43.3465 7.17558 44.0786 6.88248 44.9361 6.88248C45.363 6.88248 45.77 6.96847 46.1584 7.12834C46.5456 7.28942 46.8608 7.50743 47.0891 7.7763L46.5704 8.28741C46.1721 7.82839 45.6298 7.6019 44.9361 7.6019C44.3107 7.6019 43.7684 7.81506 43.308 8.24502C42.8526 8.67619 42.6243 9.23453 42.6243 9.92004C42.6243 10.6055 42.8526 11.1687 43.308 11.5999C43.7684 12.025 44.3107 12.243 44.9361 12.243C45.6 12.243 46.1584 12.025 46.599 11.5951C46.8893 11.3104 47.0544 10.918 47.0978 10.4166H44.9361V9.71657H47.82C47.8548 9.86796 47.8647 10.0145 47.8647 10.1562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4415 7.72905H49.7319V9.57H52.1746V10.27H49.7319V12.111H52.4415V12.8244H48.9648V7.01569H52.4415V7.72905Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6705 12.8244H54.9037V7.72905H53.2422V7.01569H57.3332V7.72905H55.6705V12.8244Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.293 12.8244V7.01569H61.0584V12.8244H60.293Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4517 12.8244H63.6911V7.72905H62.0234V7.01569H66.1194V7.72905H64.4517V12.8244Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8665 12.0771C73.2795 12.6645 72.5523 12.9576 71.6849 12.9576C70.8126 12.9576 70.0854 12.6645 69.4984 12.0771C68.9127 11.4909 68.6211 10.7715 68.6211 9.92004C68.6211 9.0686 68.9127 8.34918 69.4984 7.76298C70.0854 7.17558 70.8126 6.88248 71.6849 6.88248C72.5474 6.88248 73.2746 7.17557 73.8615 7.76783C74.4522 8.35887 74.7438 9.07345 74.7438 9.92004C74.7438 10.7715 74.4522 11.4909 73.8665 12.0771ZM70.0655 11.5902C70.5073 12.025 71.0446 12.243 71.6849 12.243C72.3203 12.243 72.8626 12.025 73.2994 11.5902C73.7399 11.1554 73.9633 10.5971 73.9633 9.92004C73.9633 9.24301 73.7399 8.68467 73.2994 8.24986C72.8626 7.81506 72.3203 7.59705 71.6849 7.59705C71.0446 7.59705 70.5073 7.81506 70.0655 8.24986C69.625 8.68467 69.4016 9.24301 69.4016 9.92004C69.4016 10.5971 69.625 11.1554 70.0655 11.5902Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8164 12.8244V7.01569H76.747L79.6406 11.5333H79.6741L79.6406 10.4166V7.01569H80.4062V12.8244H79.6071L76.577 8.08392H76.5435L76.577 9.20544V12.8244H75.8164Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4313 21.3073C66.0997 21.3073 64.1951 23.0392 64.1951 25.4288C64.1951 27.799 66.0997 29.5491 68.4313 29.5491C70.7677 29.5491 72.6724 27.799 72.6724 25.4288C72.6724 23.0392 70.7677 21.3073 68.4313 21.3073ZM68.4313 27.9262C67.152 27.9262 66.0514 26.8955 66.0514 25.4288C66.0514 23.9427 67.152 22.9302 68.4313 22.9302C69.7105 22.9302 70.8161 23.9427 70.8161 25.4288C70.8161 26.8955 69.7105 27.9262 68.4313 27.9262ZM59.1884 21.3073C56.8519 21.3073 54.9522 23.0392 54.9522 25.4288C54.9522 27.799 56.8519 29.5491 59.1884 29.5491C61.5236 29.5491 63.4245 27.799 63.4245 25.4288C63.4245 23.0392 61.5236 21.3073 59.1884 21.3073ZM59.1884 27.9262C57.9078 27.9262 56.8035 26.8955 56.8035 25.4288C56.8035 23.9427 57.9078 22.9302 59.1884 22.9302C60.4676 22.9302 61.5683 23.9427 61.5683 25.4288C61.5683 26.8955 60.4676 27.9262 59.1884 27.9262ZM48.1897 22.5705V24.3218H52.4743C52.3489 25.3004 52.0139 26.0199 51.5002 26.5213C50.8748 27.1268 49.9008 27.799 48.1897 27.799C45.5529 27.799 43.4882 25.7219 43.4882 23.1482C43.4882 20.5745 45.5529 18.4974 48.1897 18.4974C49.6154 18.4974 50.6527 19.0412 51.4183 19.7461L52.6827 18.5119C51.6119 17.514 50.1874 16.7473 48.1897 16.7473C44.5739 16.7473 41.5352 19.6189 41.5352 23.1482C41.5352 26.6775 44.5739 29.5491 48.1897 29.5491C50.144 29.5491 51.6119 28.9242 52.7659 27.7518C53.9484 26.5976 54.3169 24.9746 54.3169 23.6642C54.3169 23.2572 54.2821 22.883 54.2201 22.5705H48.1897ZM93.1646 23.9282C92.8159 23.0065 91.7401 21.3073 89.5488 21.3073C87.3774 21.3073 85.5695 22.9775 85.5695 25.4288C85.5695 27.7373 87.3588 29.5491 89.7573 29.5491C91.6967 29.5491 92.8159 28.3949 93.2763 27.7227L91.8369 26.7865C91.3567 27.472 90.7028 27.9262 89.7573 27.9262C88.818 27.9262 88.1442 27.5059 87.7124 26.6775L93.3594 24.3969L93.1646 23.9282ZM87.4072 25.3004C87.3588 23.7114 88.6716 22.8975 89.6121 22.8975C90.3492 22.8975 90.9746 23.2572 91.183 23.772L87.4072 25.3004ZM82.8174 29.2984H84.6736V17.1869H82.8174V29.2984ZM79.7774 22.2253H79.7153C79.2984 21.7433 78.503 21.3073 77.4955 21.3073C75.3811 21.3073 73.4479 23.1192 73.4479 25.4421C73.4479 27.7518 75.3811 29.5491 77.4955 29.5491C78.503 29.5491 79.2984 29.1095 79.7153 28.6129H79.7774V29.204C79.7774 30.7797 78.915 31.6263 77.524 31.6263C76.3899 31.6263 75.6864 30.8269 75.396 30.1547L73.7817 30.8124C74.247 31.9048 75.4791 33.2492 77.524 33.2492C79.7004 33.2492 81.5368 31.9993 81.5368 28.9581V21.558H79.7774V22.2253ZM77.6543 27.9262C76.375 27.9262 75.3042 26.881 75.3042 25.4421C75.3042 23.99 76.375 22.9302 77.6543 22.9302C78.915 22.9302 79.9089 23.99 79.9089 25.4421C79.9089 26.881 78.915 27.9262 77.6543 27.9262ZM101.855 17.1869H97.4157V29.2984H99.267V24.7094H101.855C103.911 24.7094 105.928 23.2572 105.928 20.9476C105.928 18.6391 103.906 17.1869 101.855 17.1869ZM101.904 23.0247H99.267V18.8717H101.904C103.286 18.8717 104.075 19.992 104.075 20.9476C104.075 21.885 103.286 23.0247 101.904 23.0247ZM113.348 21.2843C112.01 21.2843 110.619 21.8608 110.047 23.1385L111.69 23.8107C112.044 23.1385 112.694 22.9205 113.381 22.9205C114.342 22.9205 115.316 23.4837 115.331 24.4781V24.6052C114.996 24.4163 114.278 24.1365 113.396 24.1365C111.627 24.1365 109.824 25.0873 109.824 26.8616C109.824 28.4845 111.273 29.5298 112.902 29.5298C114.148 29.5298 114.836 28.9811 115.267 28.3428H115.331V29.2791H117.119V24.6331C117.119 22.4857 115.476 21.2843 113.348 21.2843ZM113.125 27.9214C112.519 27.9214 111.675 27.6283 111.675 26.8955C111.675 25.9581 112.727 25.5984 113.638 25.5984C114.453 25.5984 114.836 25.774 115.331 26.0053C115.186 27.1268 114.197 27.9214 113.125 27.9214ZM123.633 21.5495L121.505 26.7998H121.442L119.242 21.5495H117.245L120.551 28.8866L118.665 32.9694H120.599L125.693 21.5495H123.633ZM106.945 29.2984H108.801V17.1869H106.945V29.2984Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1557 7.53527C10.8641 7.83322 10.6953 8.29709 10.6953 8.89782V30.3255C10.6953 30.9262 10.8641 31.3901 11.1557 31.688L11.2276 31.7534L23.5292 19.7509V19.4675L11.2276 7.46503L11.1557 7.53527Z",
    fill: "url(#paint0_linear_290_2704)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6233 23.7538L23.5273 19.7509V19.4675L27.6283 15.4646L27.7201 15.5167L32.5767 18.214C33.9627 18.9794 33.9627 20.239 32.5767 21.0093L27.7201 23.7017L27.6233 23.7538Z",
    fill: "url(#paint1_linear_290_2704)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7225 23.7017L23.5297 19.6092L11.1562 31.688C11.6166 32.1604 12.3673 32.2173 13.221 31.7449L27.7225 23.7017Z",
    fill: "url(#paint2_linear_290_2704)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7225 15.5168L13.221 7.47351C12.3673 7.00601 11.6166 7.06293 11.1562 7.53528L23.5297 19.6092L27.7225 15.5168Z",
    fill: "url(#paint3_linear_290_2704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_290_2704",
    x1: 22.4369,
    y1: 30.5486,
    x2: 6.1809,
    y2: 13.8943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_290_2704",
    x1: 34.3815,
    y1: 19.6078,
    x2: 10.3622,
    y2: 19.6078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_290_2704",
    x1: 25.4426,
    y1: 17.3845,
    x2: 3.3981,
    y2: -5.20013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_290_2704",
    x1: 8.04158,
    y1: 38.8169,
    x2: 17.8854,
    y2: 28.7319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplayIcon);
export default __webpack_public_path__ + "static/media/googleplay-icon.4561fde96dba673bfa80062287ee8730.svg";
export { ForwardRef as ReactComponent };